import { useClient } from "../composables/useClient"
import { AppErrors, AppError, handleAppError } from "../utils/error"
import type { CreateUser } from "../utils/types"
import { UserSchema, JourneyDataSchema } from "../utils/types"

export const fetchJourney = async () => {
  const { GET } = useClient()
  const journeyStore = useJourneyStore()

  try {
    const { data, error } = await GET("/api/journey/me")

    if (error) {
      throw new AppError(AppErrors.FetchJourneyRequest)
    }

    const validation = JourneyDataSchema.safeParse(data)
    if (!validation.success) {
      console.log(validation.error.message)
      throw new AppError(AppErrors.FetchJourneyResponse)
    }

    journeyStore.setJourneyData(validation.data)
  } catch (error) {
    handleAppError(error, new AppError(AppErrors.FetchJourney))
  }
}

export const fetchUser = async () => {
  const { GET } = useClient()
  const userStore = useUserStore()

  try {
    if (userStore.id && userStore.token) {
      const { data, error } = await GET("/api/journey/users/{id}", {
        params: {
          path: {
            id: userStore.id
          }
        }
      })

      if (error) {
        throw new AppError(AppErrors.ValidateUserRequest)
      }

      const validation = UserSchema.safeParse(data)
      if (!validation.success) {
        console.log(validation.error.message)
        throw new AppError(AppErrors.ValidateUserResponse)
      }

      userStore.setUser(validation.data.id, validation.data.token)
    } else {
      throw new AppError(AppErrors.ValidateUserStoreEmpty)
    }
  } catch (error) {
    handleAppError(error, new AppError(AppErrors.ValidateUser))
  }
}

const createUser = async (ticketId: string) => {
  const { POST } = useClient()
  const userStore = useUserStore()

  try {
    const requestBody: CreateUser = { user: { ticket_id: ticketId } }
    const { data, error } = await POST("/api/journey/users", {
      body: requestBody
    })

    if (error) {
      throw new AppError(AppErrors.CreateUserRequest)
    }

    const validation = UserSchema.safeParse(data)
    if (!validation.success) {
      console.log(validation.error.message)
      throw new AppError(AppErrors.CreateUserResponse)
    }

    userStore.setUser(validation.data.id, validation.data.token)
  } catch (error) {
    handleAppError(error, new AppError(AppErrors.CreateUser))
  }
}

export const handleTicket = async () => {
  const search = window.location.search
  const searchParams = new URLSearchParams(search)
  const ticketId = searchParams.get("ticket_id")

  if (ticketId) {
    await createUser(ticketId)
  }
}
